"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Alert;

var React = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/* eslint-disable */


function Alert(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(_Icon.default, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M13.609 3.247l8.191 15.8c.1.2.2.5.2.8 0 1-.8 1.8-1.798 1.8H3.719c-.3 0-.5-.1-.8-.2-.799-.5-1.198-1.5-.699-2.4a14906.64 14906.64 0 0 1 8.292-15.8c.331-.622.868-.889 1.481-.897.614-.008 1.273.28 1.616.897zM12 18.95a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6zm-.89-10.203v5.4c0 .5.4.9.9.9s.9-.4.9-.9v-5.3c0-.5-.4-.9-.9-.9s-.9.4-.9.8z"
  }));
}